var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCamera48Line = function SvgIconCamera48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 37.7H13.6a5.31 5.31 0 0 1-5.3-5.3V20.6a5.31 5.31 0 0 1 5.3-5.3H16l1.45-2.43A5.36 5.36 0 0 1 22 10.3h4a5.361 5.361 0 0 1 4.55 2.57L32 15.3h2.4a5.31 5.31 0 0 1 5.3 5.3v11.8a5.31 5.31 0 0 1-5.3 5.3Zm-20.8-19a1.9 1.9 0 0 0-1.9 1.9v11.8a1.9 1.9 0 0 0 1.9 1.9h20.8a1.9 1.9 0 0 0 1.9-1.9V20.6a1.9 1.9 0 0 0-1.9-1.9H31a1.689 1.689 0 0 1-1.46-.83l-1.95-3.25A1.901 1.901 0 0 0 26 13.7h-4a1.902 1.902 0 0 0-1.63.92l-1.95 3.25a1.69 1.69 0 0 1-1.42.83h-3.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.2a6.7 6.7 0 1 1 6.7-6.7 6.71 6.71 0 0 1-6.7 6.7Zm0-10a3.3 3.3 0 1 0 .001 6.6 3.3 3.3 0 0 0 0-6.6ZM33.5 23.2a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4Z",
    fill: "current"
  })));
};
export default SvgIconCamera48Line;